/** @jsxImportSource @emotion/react */
import Header from '../components/header';
import Info from '../components/info';
import Menu from '../components/menu';
import ModuleSelect from '../components/module-select';
import Screenshot from '../components/screenshot';
import ScreenshotStatus from '../components/screenshot-status';

const S4Desktop = ({ selectModule, currentModuleId, openVideoGallery }) => (
  <div
    css={{
      alignItems: 'stretch',
      flexDirection: 'row',
      '>div:nth-of-type(1)': {
        flexBasis: '50%',
        flexShrink: 1,
        marginRight: 30,
        '@media (min-width:1366px)': { marginRight: 50, flexShrink: 0 },
      },
      '>div:nth-of-type(2)': {
        flexBasis: '50%',
        flexShrink: 1,
      },
      width: '100%',
    }}
  >
    <Screenshot currentModuleId={currentModuleId} openVideoGallery={openVideoGallery} />

    <div css={{ flexDirection: 'column' }}>
      <Header />
      <Menu currentModuleId={currentModuleId} selectModule={selectModule} />
      <Info currentModuleId={currentModuleId} />

      <ScreenshotStatus currentModuleId={currentModuleId} />

      <ModuleSelect currentModuleId={currentModuleId} selectModule={selectModule} />
    </div>
  </div>
);

export default S4Desktop;
